module.exports = __webpack_public_path__ + "img/diamond-dancer.4f1a064b.png";